class SemanticSearch extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.cachedResults = {}
        this.form = this.querySelector('form.search-form')
        this.input = this.querySelector('input[type="search"]')
        this.predictiveSearchResults = this.querySelector(
            '[data-predictive-search] .search__results__wrapper_custom'
        )
        this.isOpen = false
        this.closeButton = this.querySelector('[data-close-popdown]')
        // this.storeSearch()
        this.setupEventListeners()

        // Add event listener for clicks outside and Escape key
        document.addEventListener('click', this.handleClickOutside.bind(this));

        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => {
                this.handleClose()
            });
        }

        document.addEventListener('keydown', this.handleEscapeKey.bind(this));
    }

    debounceSearch(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    setupEventListeners() {
        this.input.addEventListener(
            'input',
            this.debounceSearch((event) => this.onChange(event), 300)
        );
        this.input.addEventListener('focus', this.onFocus.bind(this));
    }

    getQuery() {
        return this.input.value.trim()
    }

    onChange() {
        const searchTerm = this.getQuery()

        if (!searchTerm.length) {
            // this.showPreviousSearches()
            this.close(true)
            return
        }
        // this.hidePreviousSearches()

        this.getSearchResults(searchTerm)
    }

    onFocus(e) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        e.preventDefault()
        const searchTerm = this.getQuery()

        if (!searchTerm.length) {
            // this.showPreviousSearches()
            return
        }

        // this.hidePreviousSearches()

        if (this.getAttribute('results') === 'true') {
            this.open()
        } else {
            this.getSearchResults(searchTerm)
        }
    }


    // SEARCH FUNCTION HERE
    getSearchResults = async (searchTerm) => {
        // console.log('searchTerm', searchTerm)
        // Construct the search URL
        let searchFetchURL = `/search?section_id=api-search-results&q=${encodeURIComponent(searchTerm)}`;
        let searchFetchPredictiveURL = `/search/suggest?section_id=api-search-results&q=${encodeURIComponent(searchTerm)}`;
        // console.log('searchFetchURL', searchFetchURL)
        try {
            // Fetch both semantic and predictive search concurrently
            const [semanticRes, predictiveRes] = await Promise.all([
                fetch(searchFetchURL),
                fetch(searchFetchPredictiveURL)
            ]);

            if (!semanticRes.ok) throw new Error('Semantic search request failed');
            if (!predictiveRes.ok) throw new Error('Predictive search request failed');

            // Parse semantic HTML
            const semanticHtml = await semanticRes.text();
            const semanticDoc = new DOMParser()
                .parseFromString(semanticHtml, 'text/html')
                .querySelector('#shopify-section-api-search-results');

            let resultsMarkup = semanticDoc.innerHTML;
            const results = parseInt(
                semanticDoc.querySelector('[data-products]').dataset.products
            );

            // Parse predictive HTML (this is also coming back as a section)
            const predictiveHtml = await predictiveRes.text();
            const predictiveDoc = new DOMParser()
                .parseFromString(predictiveHtml, 'text/html')
                .querySelector('#shopify-section-api-search-results');

            // If predictive markup exists, append it
            if (predictiveDoc) {
                resultsMarkup += predictiveDoc.innerHTML;
            }

            // Track with Klaviyo
            this.klaviyoTrack(searchTerm, results);

            // Render combined markup
            this.renderSearchResults(resultsMarkup);

        } catch (error) {
            console.error(`Error fetching products for search term ${searchTerm}:`, error);
            return null;
        }

    };

    renderSearchResults(resultsMarkup) {
        // console.log('resultsMarkup', resultsMarkup)
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.setAttribute('results', true)
        // this.renderKlaviyoWidgets()
        this.open()
    }

    open() {
        this.setAttribute('open', true)
        this.input.setAttribute('aria-expanded', true)
        this.isOpen = true
    }

    close(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = ''
            this.removeAttribute('results')
        }

        const selected = this.querySelector('[aria-selected="true"]')

        if (selected) selected.setAttribute('aria-selected', false)

        this.input.setAttribute('aria-activedescendant', '')
        this.removeAttribute('open')
        this.input.setAttribute('aria-expanded', false)
        this.predictiveSearchResults.removeAttribute('style')

        this.isOpen = false
    }

    handleClickOutside(event) {
        if (!this.contains(event.target)) {
            // this.hidePreviousSearches();
            this.close(true);
            this.input.blur();
        }
    }

    handleEscapeKey(event) {
        if (event.key === 'Escape') {
            // this.hidePreviousSearches();
            this.close(true);
            this.input.blur();
        }
    }

    handleClose() {
        // console.log("handleClose")
        this.close(true);
        this.input.blur();
    }

    // Track search with klaviyo
    klaviyoTrack(searchTerm, results) {
        _learnq.push([
            'track',
            'Searched Site',
            {
                SearchTerm: searchTerm,
                ReturnedResults: results,
            },
        ])
    }

}

customElements.define('semantic-search', SemanticSearch)